<template>
  <CContainer fluid>
    <h3>Indicadores Eventos en Facturas de Venta</h3>
    <CCard class="mt-4">
      <CCardHeader>
        <CRow>
          <CCol col="sm-3">
            <label class="col-sm-12 text-muted font-weight-bold">
              Fecha Inicial:
            </label>
            <DatePicker 
              type="date" 
              class="col-sm-12" 
              v-model="fechaInicial" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/yyyy" />
          </CCol>
          <CCol col="sm-3">
            <label class="col-sm-12 text-muted font-weight-bold">
              Fecha Final:
            </label>
            <DatePicker 
              type="date" 
              class="col-sm-12" 
              v-model="fechaFinal" 
              value-type="YYYY-MM-DD" 
              format="DD/MM/YYYY"
              placeholder="dd/mm/yyyy" />
          </CCol>
          <CCol col="sm-6">
            <CButton 
              color="info" 
              variant="outline" 
              class="mt-4" 
              @click="getDataKPISales()">
              <CIcon name="cil-search" />
              <span class="ml-2 align-middle">Consultar</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol col="sm-3">
            <CWidgetProgressIcon 
              color="s3green" 
              text="Valor de Ventas" 
              :value="0"
              :header="'$' + formatter.format(valorMercancia, 2) + 'M'">
              <template #progress>
                <!-- <a href="#" v-if="$store.state.user.data.tipo_Empleado !== 'V'" -->
                <a href="#" 
                  class="ml-2" 
                  @click="() => {
                    showChart = true
                    showDetailSales = !showDetailSales
                  }">
                  <i :class="showDetailSales ? 'bi bi-caret-up-square' : 'bi bi-caret-down-square'"></i>
                </a>
                <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'V'" 
                  class="ml-2" 
                  @click="() => {
                    renderGridSalesProfit = true
                    tipoReporte = 'C'
                    updateComponentGrid += 1
                    showPanelDetailUtility = true
                  }">
                  <i class="bi bi-journal-text"></i>
                </a>
              </template>
              <i class="bi bi-cart3 h1 text-s3green"></i>
            </CWidgetProgressIcon>
          </CCol>
          <CCol col="sm-3">
            <CWidgetProgressIcon text="Valor Costo" color="warning" :value="participacionCosto"
              :header="'$' + formatter.format(valorCosto, 2) + 'M'">
              <template #progress>
                &nbsp;
              </template>
              <i class="bi bi-cash-stack h1 text-warning"></i>
            </CWidgetProgressIcon>
          </CCol>
          <CCol col="sm-3">
            <CWidgetProgressIcon text="Valor Utilidad" color="info" :value="porcentajeUtilidad"
              :header="'$' + formatter.format(valorUtilidad, 2) + 'M'">
              <template #progress>
                &nbsp;
                <!-- <a href="#" @click="() => showDetailUtility = !showDetailUtility">
                                <i class="bi bi-caret-down-square ml-2"></i>
                            </a> -->
              </template>
              <span class="small text-info mr-2">{{ porcentajeUtilidad }}%</span>
              <i class="bi bi-graph-up-arrow h1 text-info"></i>
            </CWidgetProgressIcon>
          </CCol>
          <CCol col="sm-3">
            <CWidgetProgressIcon text="Remisiones" color="s3red" :value="51"
              :header="'$' + formatter.format(123.45, 2) + 'M'">
              <template #progress>
                &nbsp;
              </template>
              <span class="small text-s3red mr-2">00.00%</span>
              <i class="bi bi-box-seam h1 text-s3red"></i>
            </CWidgetProgressIcon>
          </CCol>
        </CRow>
        <CRow>
          <CCol col="sm-12">
          </CCol>
        </CRow>
      </CCardBody>

      <CElementCover v-show="loading" />
    </CCard>
  </CContainer>
</template>

<style scoped>
  @import "../../../assets/css/metro-menu.css";
</style>

<script>
  import "vue2-datepicker/index.css";

  import moment from "moment";
  import DatePicker from "vue2-datepicker";
  import { formatter } from "@/general";
  
  export default {
    name: "DashboardEventsSalesInvoices",
    components: {
      DatePicker
    },
    data() {
      return {
        formatter,
        loading: false,
        rootPath: "",
        updateComponent: 0,
        fechaInicial: "",
        fechaFinal: ""
      }
    },
    methods: {
      async getDataEventsSalesInvoices() {
        this.loading = true;

        try {
          this.updateComponent += 1;
        } catch(error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];
      this.fechaInicial = moment().startOf("month").format("YYYY-MM-DD");
      this.fechaFinal = moment().format("YYYY-MM-DD");

      console.log(this.rootPath);
    },
    beforeDestroy() {
      
    }
  }
</script>
